module.exports = {
        srcSet: __webpack_public_path__ + "amenities_costa-197-ed78676d831cd633.digested.png"+" 197w",
        images: [{path: __webpack_public_path__ + "amenities_costa-197-ed78676d831cd633.digested.png",width: 197,height: 195}],
        src: __webpack_public_path__ + "amenities_costa-197-ed78676d831cd633.digested.png",
        toString: function(){return __webpack_public_path__ + "amenities_costa-197-ed78676d831cd633.digested.png"},
        
        width: 197,
        height: 195
      }